import React from 'react';
import { Route, NavLink, Link, withRouter, Redirect } from 'react-router-dom'
import Home from '../home'
import About from '../about'
import Music from '../music'
import Photography from '../photography'
import Logo from '../../images/logo_light.svg'
import Login from '../login'
import Settings from '../settings'
import { logout } from '../../modules/auth'
import store from '../../store'

function isLoggedIn() {
  return localStorage.getItem('loggedIn')
}

const App = () => (
  <div>
    
    {isLoggedIn() && <Header />}
    <Main />
    
  </div>
)

const MyNavLink = ({ children, ...props }) => (
  <NavLink activeClassName="active" {...props}>
    {children}
  </NavLink>
);

const Header = () => (
  <header>
    <div id="logo">
      <img src={Logo} />
    </div>
    <div id="links">
      <ul>
        <li><MyNavLink to="/music">Music</MyNavLink></li>
        <li><MyNavLink to="/photography">Photography</MyNavLink></li>
        <li><MyNavLink to="/settings">Settings</MyNavLink></li>
        <li><MyNavLink to="/logout" onClick={() => store.dispatch(logout())}>Logout</MyNavLink></li>
      </ul>
    </div>
  </header>
)

const Main = () => (
  <main>
      <PrivateRoute exact path="/about-us" component={About} />
      <PrivateRoute exact path="/music" component={Music} />
      <PrivateRoute exact path="/photography" component={Photography} />
      <PrivateRoute exact path="/settings" component={Settings} />
      <Route exact path="/login" component={Login} />
  </main>
)

function PrivateRoute ({component: Component, ...rest}) {
  return (
    <Route
      {...rest}
      render={(props) => isLoggedIn()
        ? <Component {...props} />
        : <Redirect to={{pathname: '/login', state: {from: props.location}}} />}
    />
  )
}

export default App


// WEBPACK FOOTER //
// ./src/containers/app/index.js